// extracted by mini-css-extract-plugin
var _1 = "jEtmyGkBchucviRO_v7v";
var _2 = "C87ZYwD6Qty1j909UvfO";
export { _1 as "CMSSection", _2 as "reportWrapper" }
